import React from "react";
import FloatingContainer from "../common/containers/FloatingContainer";
import DeviceSelector from "./DeviceSelector";
import PlaybackInfo from "./PlaybackInfo";
import RandomQueueToggle from "./RandomQueueToggle";
import { NextAlbumButton, NextSongButton, PlayPauseButton, PreviousAlbumButton, PreviousSongButton } from "./PlayerButtons";
import { useViewport } from "../../hooks/others/useViewport";
import { PLAYER_BUTTONS_SIZE, PLAYER_PHANTOM_HEIGHT } from "../../utils/constants/viewConstants";
import MainColorContainer from "../common/containers/MainColorContainer";

const Player = () => {
    const phantomHeight = useViewport(PLAYER_PHANTOM_HEIGHT);

    const buttonsSize = useViewport(PLAYER_BUTTONS_SIZE);

    const ButtonsXS = () => {
        return (
            <div className="d-flex flex-row jc-end gap-0_5">
                <PlayPauseButton size={buttonsSize} />
                <DeviceSelector size={buttonsSize} />
                <RandomQueueToggle size={buttonsSize} />
            </div>
        )
    }

    const ButtonsMD = () => {
        return (
            <>
                <div className="flex-1 d-flex flex-row ai-center jc-center gap-0_5">
                    <PreviousAlbumButton size={buttonsSize} />
                    <PreviousSongButton size={buttonsSize} />
                    <PlayPauseButton size={buttonsSize} />
                    <NextSongButton size={buttonsSize} />
                    <NextAlbumButton size={buttonsSize} />
                </div>
                <div className="flex-1 d-flex flex-row ai-center jc-end gap-0_5">
                    <DeviceSelector size={buttonsSize} />
                    <RandomQueueToggle size={buttonsSize} />
                </div>
            </>
        )
    }

    const Buttons = useViewport({
        xs: ButtonsXS,
        sm: ButtonsMD
    });

    return (
        <>
            <FloatingContainer position="bottom" phantomSize={phantomHeight}>
                <MainColorContainer className="d-flex flex-row jc-center ai-center gap-0_5 full-height py-0_5 px-1 bs-border-box">
                    <div className="flex-1">
                        <PlaybackInfo />
                    </div>
                    <Buttons />
                </MainColorContainer>
            </FloatingContainer>
        </>
    )
}

export default React.memo(Player);